import { Aspect } from "@oysterhr/schema"
import { useResellerAspects } from "../queries/useResellerAspects"

const useGetNewAspect = ({ id, availableAspects }: { id: string; availableAspects: Aspect[] }) => {
  const foundAspect = availableAspects.find(aspect => id === aspect.id)
  const { data, loading } = useResellerAspects({
    variables: { id },
    skip: !id || !!foundAspect?.id,
  })
  const currentResellerAspect = data?.resellerAspects?.collection[0]

  if (loading) return false

  return foundAspect || currentResellerAspect
}

export default useGetNewAspect
